import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { StatusChipService } from '../shared/status-chip.service';
import { AsyncPipe, NgIf, NgClass } from '@angular/common';

@Component({
  selector: 'em-recommendation-status-chip',
  standalone: true,
  imports: [MatIcon, CommonModule, AsyncPipe, NgIf, NgClass],
  templateUrl: './recommendation-status-chip.component.html',
  styleUrl: './recommendation-status-chip.component.css',
})
export class RecommendationStatusChipComponent {
  type$ = this.sc.type$;
  showTooltip = false;

  constructor(private sc: StatusChipService) {}

  tooltipExisting = `
    <b>Grüne Färbung:</b> Je dunkler die Färbung, desto stärker die Empfehlung <br>
    <b>Element-Verdichtung:</b> Zeigt, welche Element-Verbindungen die KI zwischen den selektierten Elementen der Auswahlleiste bzw. deines Netzwerks empfiehlt.<br>
    <b>Misfit-Auflösung:</b> Zeigt, welche Elemente die KI als Lösung für die selektierten Misfits der Auswahlleiste bzw. für die Misfits auf dem Kartentisch empfiehlt.<br>
  `;

  tooltipExtension = `
    <b>Gelbe Färbung:</b> Je dunkler die Färbung, desto stärker die Empfehlung <br>
    <b>Element-Erweiterung:</b> Zeigt, welche neuen Element-Verbindungen die KI zu oder ausgehend von neuen Elementen empfiehlt.<br>
    <b>Misfit-Erweiterung:</b> Zeigt, auf welche Misfits die KI ausgehend von den selektierten Elementen der Auswahlleiste bzw. deines Netzwerks hinweist.<br>
  `;

}
